"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Credentials = void 0;
const unicrypto_1 = require("unicrypto");
const uparsecjs_1 = require("uparsecjs");
const PasswordKeyGenerator_1 = require("./PasswordKeyGenerator");
const SharedBox_1 = require("./SharedBox");
const MapSerializer_1 = require("./MapSerializer");
/**
 * Calculate parts of MyOnly.cloud login/registration data, e.g. loginHash, loginKey and storageKey.
 */
class Credentials {
    static deriveLoginHash(login) {
        return unicrypto_1.SHA.getDigest("sha3_384", uparsecjs_1.utf8ToBytes(login.toLowerCase().trim()))
            .then(bytes => unicrypto_1.encode64(bytes));
    }
    static async deriveKeysFromPassword(password, rounds = 150000) {
        const passwordKeys = await PasswordKeyGenerator_1.PasswordKeyGenerator.generateKeys(password, 2, uparsecjs_1.utf8ToBytes("myo.cloud.login"), rounds, "SHA256");
        return {
            loginAccessKey: passwordKeys[0],
            storageKey: passwordKeys[1]
        };
    }
    static async decryptCloudKeys(password, encryptedKey) {
        const sb = await SharedBox_1.SharedBox.unpack(encryptedKey);
        const passwordKeys = await Credentials.deriveKeysFromPassword(password);
        await sb.unlockWithKeys(passwordKeys.loginAccessKey);
        console.log(await unicrypto_1.Boss.load(await sb.payloadPromise));
        return {
            loginKey: await MapSerializer_1.fromBoss(await sb.payloadPromise, "loginKey"),
            storageKey: passwordKeys.storageKey
        };
    }
    static async encryptLoginKey(loginKey, password) {
        // key derivation in parallel
        const keysPromise = Credentials.deriveKeysFromPassword(password);
        // ... with sharedbox creation
        const sb = await SharedBox_1.SharedBox.createWith({ loginKey: loginKey });
        const keys = await keysPromise;
        await sb.addKeys(keys.loginAccessKey);
        return await sb.pack();
    }
}
exports.Credentials = Credentials;
// MapSerialization initialization: do not remove
SharedBox_1.SharedBox;
//# sourceMappingURL=Credentials.js.map